<template>
  <div>
    <div class="w-full space-y-6">
      <h2 class="font-serif text-3xl font-bold text-center text-gray-900">
        Create Account
      </h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Full Name"
          v-model="form.name"
          required
          class="form-input"
        />

        <input
          type="email"
          placeholder="Email"
          v-model="form.email"
          required
          class="form-input"
        />

        <input
          type="password"
          placeholder="Password"
          v-model="form.password"
          required
          class="form-input"
        />

        <input
          type="tel"
          placeholder="Contact (10 digits)"
          v-model="form.contact"
          required
          class="form-input"
        />

        <input
          type="text"
          placeholder="City / Village"
          v-model="form.city"
          required
          class="form-input"
        />

        <!-- STATE -->
        <select
          v-model="form.state"
          @change="onStateChange"
          required
          class="form-input"
        >
          <option value="">Select State</option>
          <option
            v-for="state in states"
            :key="state.state"
            :value="state.state"
          >
            {{ state.state }}
          </option>
        </select>

        <!-- DISTRICT -->
        <select
          v-model="form.district"
          required
          class="form-input"
        >
          <option value="">Select District</option>
          <option
            v-for="district in districts"
            :key="district"
            :value="district"
          >
            {{ district }}
          </option>
        </select>

        <button
          type="submit"
          class="btn-cream w-full py-3"
        >
          Sign Up
        </button>
      </form>

      <div class="text-center">
        <button
          @click="$emit('switch', 'login')"
          class="text-brand-red font-medium hover:underline text-sm"
        >
          Already have an account? Login
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import stateDistricts from "@/assets/state_ditricts.json";

const emit = defineEmits(["success", "error", "switch"]);

const states = ref([]);
const districts = ref([]);

const form = ref({
  name: "",
  email: "",
  password: "",
  contact: "",
  city: "",
  state: "",
  district: "",
  profile: "user",
});

onMounted(() => {
  // load local JSON
  states.value = stateDistricts;
});

const onStateChange = () => {
  const selected = states.value.find(
    (s) => s.state === form.value.state
  );
  districts.value = selected ? selected.districts : [];
  form.value.district = "";
};

const baseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

const submit = async () => {
  try {
    const res = await fetch(`${baseUrl}/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form.value),
    });

    const data = await res.json();

    if (!res.ok) {
      emit("error", data.error || "Signup failed!");
      return;
    }

    emit("success", "OTP sent!");
    sessionStorage.setItem("signupData", JSON.stringify(form.value));
    emit("switch", "otp");
  } catch {
    emit("error", "Connection error");
  }
};
</script>
